module.exports = __webpack_public_path__ + "img/undraw_road_to_knowledge_m8s0.3cc433f1.svg";